<script setup lang="ts">
import { ErrorCode } from "~/core/models/ErrorCode.enum";
import LxcError from "~/core/models/LxcError.class";

// Simulate an error in order to display the generic error message
const error = new LxcError({
  type: "about:blank",
  title: ErrorCode.UNEXPECTED,
  status: 500,
  detail: "An unexpected error occurred",
  instance: "/error",
});
</script>

<template>
  <section>
    <error-component :error="error" />
  </section>
</template>
